<template>
  <div class="footer">
    <div style="margin-right: 89px">版权所有：{{ appData.platformConfiguration.copyrightInfo }}</div>
    <a
      style="display: flex; align-items: center; color: #fff; text-decoration: none; margin-right: 89px"
      href="https://beian.miit.gov.cn"
      target="_blank"
    >
      <img style="width: 20px; margin-right: 7px" src="../../assets/gongan.png" />备案：{{
        appData.platformConfiguration.filingsInfo
      }}
    </a>
    <a href="https://www.ahaiba.com/" style="color: #fff; text-decoration: none" target="_blank">技术支持：海拔网络</a>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  computed: {
    appData() {
      return this.$store.state.appState.appData;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
